export const searchHistoryService = {
  getRecentSearches: () => [],
  addSearch: () => {}
};
